import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddOrEditTicketTagInput, Result, ResultList, TagResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class TicketTagService {

  constructor(private httpClient: HttpClient) { }

  public addOrEditTicketTag(addOrEditTicketTagInput: AddOrEditTicketTagInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'TicketTag/AddOrEditTicketTag', addOrEditTicketTagInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTicketTags(ticketId: number): Promise<ResultList<TagResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'TicketTag/GetTicketTags?ticketId=' + ticketId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TagResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TagResult>(), result.error));
  }
}
